var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudiostop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.4772 2 2 6.4771 2 12C2 17.5229 6.4772 22 12 22C17.5228 22 22 17.5229 22 12C22 6.4771 17.5228 2 12 2ZM12 20.5C7.3131 20.5 3.5 16.687 3.5 12C3.5 7.313 7.3131 3.5 12 3.5C16.6869 3.5 20.5 7.313 20.5 12C20.5 16.687 16.6869 20.5 12 20.5Z",
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.749 8.251H9.251C8.69872 8.251 8.251 8.69871 8.251 9.251V14.749C8.251 15.3013 8.69872 15.749 9.251 15.749H14.749C15.3013 15.749 15.749 15.3013 15.749 14.749V9.251C15.749 8.69871 15.3013 8.251 14.749 8.251Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiostop);
export default __webpack_public_path__ + "static/media/audiostop.23c45c77802d37d21d8c1f4c12fedbb2.svg";
export { ForwardRef as ReactComponent };